import React, { useCallback, useState } from 'react'
import { FooterSettingStyles } from './Style'
import { IconButton, Slider, SvgIcon } from '@mui/material'
import { CacheProvider } from '@emotion/react'
import { cacheRtl } from 'styles/theme'
import { cacheLtr } from 'styles/theme'
import { Pause, PlayArrow, PlayArrowSharp, Refresh, Replay } from '@mui/icons-material'
import { Button } from 'components/Form'
import { useSelector } from 'react-redux'
import { surferHooks } from '.'
import { ReactComponent as BackIcon } from 'assets/icons/Back.svg';
import { ReactComponent as NextIcon } from 'assets/icons/Next.svg';

const FooterSettings = () => {
    const [zoom, setZoom] = useState(15)

    const { isPlaying, wavesurfer } = useSelector(state => state.wavesurfer)
    const onPlayPause = surferHooks.useOnPlayPause()

    const zoomIn = useCallback((e, value) => {
        setZoom(value)
        wavesurfer.zoom(value * 10);
    }, [wavesurfer])

    const handleSeekingBack = useCallback(() => {
        wavesurfer.skip(-2)
    }, [wavesurfer])

    const handleSeekingNext = useCallback(() => {
        wavesurfer.skip(2)
    }, [wavesurfer])

    return (
        <FooterSettingStyles>
            <div className='section left'>
                <div className='speed'>
                    {"Maxi"}
                    <CacheProvider value={cacheLtr}>
                        <Slider value={zoom} onChange={zoomIn} color='thirdly' aria-label="Volume" />
                    </CacheProvider>
                    {"Mini"}
                </div>
            </div>
            <div className='section center play-btns'>
                <Button action={handleSeekingNext} variant="transparent2" size="small" label="2 sec" icon={<Refresh />}>
                    {"sec 2"}
                    <SvgIcon component={BackIcon} inheritViewBox />
                </Button>
                <IconButton onClick={onPlayPause}>
                    {isPlaying ? <Pause color="white" /> : <PlayArrowSharp color="white" />}
                </IconButton>
                <Button action={handleSeekingBack} variant="transparent2" size="small" label="2 sec" icon={<Refresh />}>
                    <SvgIcon component={NextIcon} inheritViewBox />
                    {"sec 2"}
                </Button>
            </div>
            <div className='section right'>

            </div>
        </FooterSettingStyles>
    )
}

export default FooterSettings